export default "__VITE_ASSET__CyIGEtIu__"